<div
  *ngIf="isDemoEnv"
  class="tw-bg-light-blue-500 tw-text-white tw-text-h4 tw-text-center tw-py-4 tw-absolute tw-top-0 tw-w-full"
>
  {{ envName }}
</div>

<div class="content">
  <p>{{ 'dashboard.welcome.title' | translate }}</p>
  <div class="intrack-logo"></div>
</div>
